// App
import React from 'react';

// Icons
import IconAppleAppStoreBadge from 'images/apple-badge.min.svg';
import IconAndroidPlayStoreBadge from 'images/android-badge.min.svg';

// Misc / utils
import * as S from './styles';

type AppBadgesProps = {
  onBadgeClick?: () => void;
};

const AppBadges = ({ onBadgeClick }: AppBadgesProps) => {
  return (
    <>
      {/* TODO: Look at adding view.adjust.com impression tracking for Apple app store impressions */}
      <S.Linker
        to={`https://app.us.adjust.com/sbfwuc?campaign=web&adgroup=homepageFooter&creative=ios`}
        tabIndex={0}
        onClick={onBadgeClick}
        data-footer-page={'iosApp'}
      >
        <S.BadgeImg
          loading="lazy"
          src={IconAppleAppStoreBadge}
          alt="Apple app store badge"
          width="120px"
          height="35px"
        />
      </S.Linker>
      {/* TODO: Look at adding view.adjust.com impression tracking for Android play store impressions */}
      <S.Linker
        to={`https://app.us.adjust.com/nuf8sz?campaign=web&adgroup=homepageFooter&creative=android`}
        tabIndex={0}
        onClick={onBadgeClick}
        data-footer-page={'androidApp'}
      >
        <S.BadgeImg
          loading="lazy"
          src={IconAndroidPlayStoreBadge}
          alt="Android play store badge"
          width="120px"
          height="35px"
        />
      </S.Linker>
    </>
  );
};

export default AppBadges;
